import createActionConstants from 'lib/create-action-constants'

export const constants = createActionConstants('mcp-usage', [
  'FETCH_MCP_USAGE',
  'FETCH_MCP_USAGE_SUCCESS',
  'FETCH_MCP_USAGE_FAILURE',
  'SET_MCP_OVERAGE',
  'SET_MCP_OVERAGE_FAILURE'
])

export const fetchMcpUsage = () => ({
  type: constants.FETCH_MCP_USAGE
})

// `limit` is the monthly overage cap: extra pay-as-you-go calls allowed beyond the plan
// allowance (0 turns overage off). The backend returns the refreshed usage view.
export const setMcpOverage = ({ limit }) => ({
  type: constants.SET_MCP_OVERAGE,
  payload: { limit }
})
